export default __webpack_public_path__ + "media/images/friends-cropped-4c330737786abbc73125e837304b4ec3.png";